// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__fXji8"};